
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 14 14","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M3.556 3.556v12.942l12.942-6.471L3.556 3.556zm.888 1.438l10.065 5.033-10.065 5.032V4.994z","id":"watch-a"}})]),_c('g',{attrs:{"transform":"translate(-3 -3)","fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"watch-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#watch-a"}})]),_c('use',{attrs:{"fill":"#1D1D1B","xlink:href":"#watch-a"}}),_c('g',{attrs:{"mask":"url(#watch-b)","fill":"#000"}},[_c('path',{attrs:{"d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    